// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class TerceraTIFData {
    constructor(date, tif) {
        this.date = date;
        this.tif = tif;
    }
}
